/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
import * as React from 'react';
/**
 * Позволяет управлять значением, если оно не передано
 *
 * @export
 * @template T
 * @param {IUseControlledProps<T>} { controlled, default: defaultValue }
 * @returns
 */
export function useControlled(_ref) {
  let {
    controlled,
    default: defaultValue
  } = _ref;
  const {
    current: isControlled
  } = React.useRef(controlled !== undefined);
  const [valueState, setValue] = React.useState(defaultValue);
  const value = isControlled ? controlled : valueState;
  const setValueIfUncontrolled = React.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}